export default "__VITE_ASSET__4a379467__"